import { API_URL } from "../../../Config/api";
import React, { useState, useEffect } from "react";
import { Col, Divider, Table, Tag } from "antd";
import axios from "axios";
import dayjs from "dayjs";

export default function EventosTab(props) {
  let userDrawer = props.user;

  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPurchases([]);
    fetchEventPurchases();
  }, [userDrawer]);

  const fetchEventPurchases = async () => {
    if (!userDrawer?.id) {
      return;
    }

    setLoading(true);
    try {
      const [purchasesRes, eventosRes] = await Promise.all([
        axios.get(
          `${API_URL}/event-purchases-by-userid/${userDrawer.id}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + session_storage.token,
            },
          }
        ),
        axios.get(`${API_URL}/all-eventos`),
      ]);

      const eventos = eventosRes.data.eventos || [];
      const dataSource = (purchasesRes.data.purchases || []).map((purchase) => {
        const evento = eventos.find((e) => e.id == purchase.event_id);
        return {
          ...purchase,
          evento_titulo: evento?.titulo || "N/D",
        };
      });

      setPurchases(dataSource.sort((a, b) => b.id - a.id));
    } catch (error) {
      console.log("error buscar eventos do sócio", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Evento",
      dataIndex: "evento_titulo",
    },
    {
      title: "Método",
      dataIndex: "payment_type",
    },
    {
      title: "Montante",
      dataIndex: "amount",
      render: (amount) => (Number(amount) ? `${amount} €` : "N/A"),
    },
    {
      title: "Estado",
      dataIndex: "status",
      render: (status) =>
        status != "nao pago" ? (
          <Tag color="green">Pago</Tag>
        ) : (
          <Tag color="red">Não pago</Tag>
        ),
    },
    {
      title: "Data de pagamento",
      dataIndex: "payment_valid_date",
      render: (value) => {
        if (!value) return "-";
        const date = dayjs(value);
        const hasTime = value.includes("T") || value.includes(" ");
        return hasTime
          ? date.format("DD-MM-YYYY HH[h]mm[m]")
          : date.format("DD-MM-YYYY");
      },
    },
  ];

  return (
    <Col
      style={{ padding: "30px", borderRadius: "16px", background: "#D6D7E2" }}
    >
      <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>Eventos</h5>
      <p>Eventos comprados por este sócio.</p>
      <Divider></Divider>
      <Table
        rowKey="id"
        dataSource={purchases}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 10 }}
      />
    </Col>
  );
}
